/**
 * @file CustomToggleSwitch.tsx
 * @module app/custom/toggle-switch/CustomToggleSwitch
 * @description Renders the CustomToggleSwitch control for toggling boolean settings and workflow state.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import React from "react";

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
    size?: "sm" | "md" | "lg";
}

const sizeMap = {
    sm: "w-35px h-20px",
    md: "w-50px h-30px",
    lg: "w-65px h-35px",
};

export const CustomToggleSwitch: React.FC<ToggleSwitchProps> = ({
    checked,
    onChange,
    disabled = false,
    size = "md",
}) => {
    return (
        <label className="form-check form-switch form-check-custom form-check-solid">
            <input
                type="checkbox"
                className={`form-check-input form-check-success ${sizeMap[size]}`}
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
            />
        </label>
    );
};
